import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function InviteFriends({ openInviteLinkModal, setOpenInviteLinkModal, user }) {
  const { t } = useTranslation();
  const [inviteLink, setInviteLink] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);

  useEffect(() => {
    if (user) {
      const referralCode = user?.referral_code || user?.id || "guest";
      const link = `${window.location.origin}/auth/register?ref=${referralCode}`;
      setInviteLink(link);
    }
  }, [user]);

  const handleCopyPath = (path) => {
    const textarea = document.createElement("textarea");
    textarea.value = path;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 1500); // reset after 1.5s
    } catch (err) {
      console.error("Copy failed", err);
    }
    document.body.removeChild(textarea);
  };

  return (
    <Dialog
      visible={openInviteLinkModal}
      style={{ width: "470px" }}
      modal
      className="m-4"
      draggable={false}
      onHide={() => setOpenInviteLinkModal(false)}
    >
      <code className="block break-all rounded bg-gray-100 p-2">{inviteLink}</code>

      <div className="mt-3 flex justify-end gap-2">
        <button
          onClick={() => handleCopyPath(inviteLink)}
          className="w-full rounded-full bg-purple-500 px-4 py-2 text-sm font-medium text-white shadow hover:bg-purple-600"
        >
          {copySuccess ? t("Copied") : t("CopyLink")}
        </button>
      </div>
    </Dialog>
  );
}
